import { render, staticRenderFns } from "./Accountant.vue?vue&type=template&id=49823b10&"
import script from "./Accountant.vue?vue&type=script&lang=js&"
export * from "./Accountant.vue?vue&type=script&lang=js&"
import style0 from "./Accountant.vue?vue&type=style&index=0&id=49823b10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports